import { createAction } from '@reduxjs/toolkit';


export const getapproveonboardingbusinessInfoRequest = createAction('GET_APPROVE_BUSINESS_INFO', (data, rowid) => {
    return{
        payload: {
			data,
			rowid
        }
    }
});

export const getapproveonboardingbusinessInfoSuccess = createAction('GET_APPROVE_BUSINESS_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getapproveonboardingbusinessInfoFailure = createAction('GET_APPROVE_BUSINESS_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});

